import React from 'react';

import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import WorkflowStageFilter from 'components/ReactTable/Filters/WorkflowStageFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import ValidationResultCell from 'components/ReactTable/CellRenderers/ValidationResultCell';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const rejectedFormColumnDefs = (permissions, isPiiProtectionEnabled, piiValidationCodes) => [
  {
    Header: 'Customer Id',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ permissions } />);
    },
    className: 'col-15p'
  },
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: WorkflowStageFilter,
    Cell: (cellInfo) => {
      const { row: { original: { workflowStatus } } } = cellInfo;
      return workflowStatus || 'N/A';
    }
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ permissions } />);
    },
    className: 'col-15p'
  },
  {
    Header: 'Reasons For Rejection',
    id: 'rejections',
    Cell: (cellInfo) => {
      const { row: { original: { validationData, formType } } } = cellInfo;
      return (<ValidationResultCell
        dataKey="rejections"
        data={ validationData }
        className="reasons-for-rejection-list"
        isPiiProtectionEnabled={ isPiiProtectionEnabled }
        piiValidationCodes={ piiValidationCodes }
        formType={ formType }
      />);
    },
    disableFilters: true,
    className: 'col-20p rejections-list'
  },
  {
    Header: 'Warnings / Instructions',
    id: 'warnings',
    Cell: (cellInfo) => {
      const { row: { original: { validationData, formType } } } = cellInfo;
      return (<ValidationResultCell
        dataKey="warnings"
        data={ validationData }
        className="red-flags-and-recs-list"
        isPiiProtectionEnabled={ isPiiProtectionEnabled }
        piiValidationCodes={ piiValidationCodes }
        formType={ formType }
      />);
    },
    disableFilters: true,
    className: 'col-20p warnings-list'
  },
  {
    Header: 'Sign Date',
    accessor: 'signDate',
    disableFilters: true,
    className: 'col-12p5'
  }
];

export default rejectedFormColumnDefs;
